'use client';

import { useState } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import HeroSection from './components/HeroSection';
import CoreValueSection from './components/CoreValueSection';
import HowItWorksSection from './components/HowItWorksSection';
import CategoriesSection from './components/CategoriesSection';
import BenefitsSection from './components/BenefitsSection';
import BeforeAfterSection from './components/BeforeAfterSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import FinalCTASection from './components/FinalCTASection';
import DownloadModal from './components/DownloadModal';
import StickyDownloadCTA from './components/StickyDownloadCTA';

export default function LandingPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <main className="min-h-screen bg-white">
      <Header />

      <HeroSection onOpenModal={openModal} />
      <CoreValueSection />
      <HowItWorksSection />
      <CategoriesSection />
      <BenefitsSection />
      <BeforeAfterSection />
      <TestimonialsSection />
      <FAQSection />
      <FinalCTASection onOpenModal={openModal} />

      <Footer />

      {/* Modals & Overlays */}
      <DownloadModal isOpen={isModalOpen} onClose={closeModal} />
      <StickyDownloadCTA onOpenModal={openModal} />
    </main>
  );
}